module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "species"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.speciesData.commonName))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.speciesData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.speciesData.picture.fields.file.url,
      "alt": "species image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "section status"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("Conservation status")]), _vm._v(" "), _c('div', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.displayInformationPopup(true)
      }
    }
  }, [_vm._m(0, false, false)])]), _vm._v(" "), _c('div', {
    staticClass: "data status"
  }, [_c('p', [_vm._v(_vm._s(_vm.speciesData.threatStatus))])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "heading closable",
    on: {
      "click": _vm.toggleAbout
    }
  }, [_c('h4', [_vm._v("About")]), _vm._v(" "), (_vm.displayAbout) ? _c('i', {
    staticClass: "fa fa-angle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.displayAbout) ? _c('i', {
    staticClass: "fa fa-angle-down"
  }) : _vm._e()]), _vm._v(" "), (_vm.displayAbout) ? _c('div', {
    staticClass: "data"
  }, [_c('p', [_vm._v(_vm._s(_vm.speciesData.about))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "heading closable",
    on: {
      "click": function($event) {
        _vm.displayFunFact = !_vm.displayFunFact
      }
    }
  }, [_c('h4', [_vm._v("Fun Fact")]), _vm._v(" "), (_vm.displayFunFact) ? _c('i', {
    staticClass: "fa fa-angle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.displayFunFact) ? _c('i', {
    staticClass: "fa fa-angle-down"
  }) : _vm._e()]), _vm._v(" "), (_vm.displayFunFact) ? _c('div', {
    staticClass: "data"
  }, [_c('p', [_vm._v(_vm._s(_vm.speciesData.fact))])]) : _vm._e()]), _vm._v(" "), (_vm.hasFirstNationsInfo) ? _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "heading closable",
    on: {
      "click": function($event) {
        _vm.displayFirstNationsInfo = !_vm.displayFirstNationsInfo
      }
    }
  }, [_c('h4', [_vm._v("Further first nations information")]), _vm._v(" "), (_vm.displayFirstNationsInfo) ? _c('i', {
    staticClass: "fa fa-angle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.displayFirstNationsInfo) ? _c('i', {
    staticClass: "fa fa-angle-down"
  }) : _vm._e()]), _vm._v(" "), (_vm.displayFirstNationsInfo) ? _c('div', {
    staticClass: "data"
  }, [_c('p', [_vm._v(_vm._s(_vm.speciesData.languageExtraInfo))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "threats"
  }, _vm._l((_vm.speciesData.threats), function(threat) {
    return _c('div', {
      key: threat.fields.name,
      staticClass: "threat"
    }, [_c('div', {
      staticClass: "threat-icon"
    }, [_c('img', {
      attrs: {
        "src": threat.fields.icon.fields.file.url,
        "alt": threat.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "threat-name"
    }, [_c('p', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(threat.fields.name))])])])
  }))])])]), _vm._v(" "), (_vm.displayExtinct) ? _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-icon",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/warning.png')"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "uppercase"
  }, [_vm._v("\n          There has been an extinction event in your area in the last 10\n          years.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.displayInformationPopup(false)
      }
    }
  }, [_vm._m(2, false, false)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('p', [_vm._v("i")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading closable"
  }, [_c('h4', [_vm._v("Key threats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon light"
  }, [_c('p', [_vm._v("i")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c750e59","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/threatened-species/HeroSpecies.vue
// module id = 768
// module chunks = 0